'use client';

import { FormEvent, useState } from 'react';
import NotFound from '../components/svg/NotFoundCode';
import Search from '../components/svg/Search';
import { useRouter } from 'next/navigation';
import ThemedImage from '../components/ThemedImage';
import Link from 'next/link';

export default function NotFoundPage() {
  const [search, setSearch] = useState('');
  const router = useRouter();


  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!search) return;
    router.push(`/search?q=${search}`);
  }

  return (
    <div className='flex flex-col items-center justify-center gap-y-[24px] py-[48px] px-[16px]'>
      <NotFound className='w-[162px] h-[88px]'/>
      <div className='flex flex-col gap-y-[8px] text-center'>
        <h1 className=''>عفواً .. الصفحة غير موجودة</h1>
        <span className='lg '>ربما تم حذف الصفحة التي تبحث عنها أو تم تغيير اسمها أو أنها غير متاحة مؤقتًا.</span>
        <span className='sm text-gray-600 dark:text-gray-500'>حاول البحث عن محتوى مماثل</span>
      </div>
      <form className='flex flex-col gap-[24px] justify-center items-center w-full' onSubmit={onSubmit}>
      <div className='h-[60px] w-full bg-white border-darkBorder border-[1.5px] p-[16px] flex items-center justify-between gap-x-[24px] max-w-[650px]'>
        <input 
        required
          className='border-none outline-none bg-transparent h-full w-full text-black'
          value={search}
          onChange={({target: {value}}) => setSearch(value)}
          placeholder='أبحث هنا'
          />
          <button className='grid place-items-center h-fit w-fit' type='submit'>
        <Search className='aspect-square w-[17px] flex-shrink-0 cursor-pointer [&>*]:stroke-black'/>
          </button>
      </div>
          </form>

      <Link href='/' title={'الصفحة الرئيسية'} className='self-center grid place-items-center h-[62px] w-fit md bg-primary text-white p-[16px] rounded-[4px]' type='submit'>
      العودة إلى الصفحة الرئيسية
      </Link>

    </div>
  )
}